import { useTranslation } from 'react-i18next';

import { PhoneClassic } from '@pulse-web-ui/icons';
import { useTheme } from '@pulse-web-ui/theme';
import type { BaseThemeType } from '@pulse-web-ui/theme';

import {
  SupportBlockContent,
  SupportBlockTitle,
  SupportButton,
  SupportButtonsWrapper,
} from './new-support.styles';

export const NewSupportBlock = () => {
  const { t } = useTranslation();
  const theme = useTheme() as BaseThemeType;

  return (
    <SupportBlockContent>
      <SupportBlockTitle>{t('AUTH:headers.contactSupport')}</SupportBlockTitle>
      <SupportButtonsWrapper>
        <SupportButton
          icon={<PhoneClassic width={19} color={theme.colors.icon.primary} />}
          onClick={() => (window.location.href = 'tel:+78003021554')}
        >
          {t('COMMON:labels.freeCall')}
        </SupportButton>
      </SupportButtonsWrapper>
    </SupportBlockContent>
  );
};
